module.exports = __webpack_public_path__ + "img/balanced.51081cdd.jpg";